import { ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { WINDOW } from '@grid-ui/common';
import { selectCurrentRouteUrl } from '@grid-ui/global-routing';
import { Store } from '@ngrx/store';
import { from } from 'rxjs';
import { DataWizardExtractNotificationService } from '../../../extract-management';
import { ServiceOffering } from '../../../home/models';
import { NavService, SvgService } from '../../services';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'nav[mc-app-side-area-links]',
  templateUrl: './app-side-area-links.component.html',
  styleUrls: ['./app-side-area-links.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  host: {
    class: 'SideLinks',
  },
})
export class AppSideAreaLinksComponent {
  protected readonly extractNotificationService = inject(DataWizardExtractNotificationService);
  private readonly navService = inject(NavService);
  private readonly router = inject(Router);
  private readonly svgService = inject(SvgService);
  private readonly window = inject(WINDOW);
  private readonly store = inject(Store);

  public readonly currentModule = signal<string | null>(null);
  public readonly navItems = toSignal<ServiceOffering[]>(from(this.navService.serviceOfferings()));

  constructor() {
    this.store
      .select(selectCurrentRouteUrl)
      .pipe(takeUntilDestroyed())
      .subscribe((url) => this.setCurrentModule(url));
  }

  public trackByIndex(_item: ServiceOffering, index: number): number {
    return index;
  }

  public getSvg(svgId: string): string {
    return this.svgService.getNavigationIcon(svgId);
  }

  public getExtSvg(url: string) {
    return this.svgService.getExtSvg(url);
  }

  public navigate(navItem: ServiceOffering): void {
    if (navItem.open_in_window) {
      this.window.open(navItem.link);
    } else {
      void this.router.navigate([navItem.link]);
    }
  }

  private setCurrentModule(url: string): void {
    const matches = /\/([\w-]+)\/?.*/.exec(url);

    if (matches?.length > 1) {
      this.currentModule.set(matches[1]);
    }
  }
}
